<template>
  <div class="product">
    <el-row>
      <el-col :span="2">&nbsp;</el-col>
      <el-col :span="20">
        <div class="titleC" @click="getStyle(0,'')">产品中心</div>
        <div class="titleE" @click="getStyle(0,'')">PRODUCT CENTER</div>
        <div class="titleLine"></div>
        <div class="allType">
          <ul>
            <li
              v-for="(item,index) in type"
              @click="getStyle(index,item)"
              :class="['menu',activeIndex == index?'actives':'']"
              :key="index"
            >
              {{item.name}}
              <!-- &nbsp;&nbsp;&nbsp;&nbsp;<span
              v-if="index+1 != type.length">/</span>&nbsp;&nbsp;&nbsp;&nbsp;-->
              <ul class="typeChild">
                <li
                  v-for="(items,indexs) in item.products_type"
                  @click.stop="getChild(index,items,item)"
                  :key="indexs"
                >{{items.name}}</li>
              </ul>
            </li>
          </ul>
        </div>
        <div class="clear"></div>
        <product ref="child"></product>
      </el-col>
      <el-col :span="2">&nbsp;</el-col>
    </el-row>
  </div>
</template>

<script>
import product from "../components/product/product.vue";
import request from "../assets/js/request.js";
import qs from "qs";
export default {
  components: {
    product,
  },
  data() {
    return {
      activeIndex: 0,
      type: [],
    };
  },
  watch: {
  	"$route.query": {
  		handler(query) {
  			let path = this.$route.path;
  			for(var i = 0;i<this.type.length;i++){
  				if(this.type[i].id == this.$route.query.id){
  					this.activeIndex = i
  				}
  			}
  		},
  	},
  },
  created() {
	  for(var i = 0;i<this.type.length;i++){
	  	if(this.type[i].id == this.$route.query.id){
	  		this.activeIndex = i
	  	}
	  }
    // this.id = this.$router.query.id;
    this.id = this.$route.query.id;

    console.log(this.id);
    request
      .post(
        this.settings.apiBaseUrl + "/api/index/youhuaseo",
        qs.stringify({}),
        {
          headers: {},
        }
      )
      .then((res) => {
        if (res.code == 1) {
        } else {
          this.$message.error(res.msg);
        }
      });
    this.getTypes();
  },
  methods: {
    getStyle(index, item) {
      (this.activeIndex = index),
        this.$refs.child.getData(item.id, "", item.name);
    },
    getChild(index, items, item) {
      this.$refs.child.getData(item.id, items.id, item.name, items.name);
    },
    getTypes() {
      request
        .post(
          this.settings.apiBaseUrl + "/api/index/products_type",
          qs.stringify({}),
          {
            headers: {},
          }
        )
        .then((res) => {
          if (res.code == 1) {
            this.type = res.data;
					
          } else {
            this.$message.error(res.msg);
          }
        });
    },
  },
  mounted() {
    console.log($(".allType ul li"));
  },
};
</script>

<style scoped="scoped">
.product {
  clear: both;
  width: 100%;
  height: auto;
}

.typeChild {
  display: none;
  position: absolute;
  width: 130%;
  height: auto;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
  z-index: 9999;
  background-color: #ffffff;
}

.typeChild li {
  width: 100%;
  height: 30px;
  line-height: 30px;
  text-align: center;
}

.typeChild li:hover {
  background-color: rgb(10, 157, 243);
  color: #ffffff;
}

.allType ul .menu {
  margin: 0 5px;
  padding: 0px 15px;
  background-color: rgb(10, 157, 243);
  color: #ffffff;
}
.actives {
  background-color: rgb(236, 144, 9) !important;
  color: #ffffff;
}
.allType ul li:hover .typeChild {
  display: block;
}

.titleC,
.titleE {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/product.vue